import { createGlobalStyle } from 'styled-components'

const BazaarGlobalStyle = createGlobalStyle`
  .bazaarvoice-container {
    margin: 60px 0 0;
    @media (min-width: ${(props) => props.theme.screen_md_min}) {
      margin: 0;
    }
    @media (min-width: ${(props) => props.theme.screen_lg_min}) {
      margin: 0 15px;
    }
  }
`

export default BazaarGlobalStyle
